import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyCX5msqd223t0ZQgM3URQzLenKrmoQipIA",
    authDomain: "pangobooks.firebaseapp.com",
    databaseURL: "https://pangobooks.firebaseio.com",
    projectId: "pangobooks",
    storageBucket: "pangobooks.appspot.com",
    messagingSenderId: "1084069003593",
    appId: "1:1084069003593:web:b5ada4457099c981c0da98",
    measurementId: "G-YB1PLFVEQG"
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig)

const db = firebaseApp.firestore();

export { db }